import React, { KeyboardEvent } from 'react';
import { useTranslator } from '../../../../../../components/i18n/useTranslator';
import { Popover } from '@milanote/roma';
import { cx } from '@milanote/roma/utils/cx';
import { LABEL_NAME_MAX_LENGTH } from '../../../../../../../common/labels/labelConstants';

const styles = {
    sm: {
        inputSize: 'md',
    },
    lg: {
        inputSize: 'lg',
    },
} as const;

type Props = {
    value: string;
    onChange: (value: string) => void;
    handleSearchSubmit: () => void;
    autoFocus: boolean;
    className?: string;
    size?: keyof typeof styles;
};

const LabelsSearchBar: React.FC<Props> = ({
    value,
    onChange,
    handleSearchSubmit,
    autoFocus,
    className,
    size = 'sm',
}) => {
    const translate = useTranslator('popup', 'labels.search');
    const sizeStyles = styles[size];

    const handleKeyDown = (event: KeyboardEvent) => {
        if (event.key === 'Enter') {
            handleSearchSubmit();
        }
    };

    return (
        <Popover.Header className={cx('LabelSearchBar border-b-0 pb-0', className)}>
            <Popover.Search
                aria-label="Enter label name"
                name="search"
                placeholder={translate('placeholder')}
                size={sizeStyles.inputSize}
                value={value}
                onChange={onChange}
                onKeyDown={handleKeyDown}
                maxLength={LABEL_NAME_MAX_LENGTH}
                autoFocus={autoFocus}
            />
        </Popover.Header>
    );
};

export default LabelsSearchBar;
